import rok from './rok'
export default {
    required: 'Pole rok produkcji jest wymagane',
    ...rok,
}